import type { FaqEntry } from '../utils/structuredData';

/** FAQ de l'accueil — source unique pour l'affichage et le JSON-LD FAQPage. */
export const HOME_FAQ_ITEMS: FaqEntry[] = [
  {
    question: 'Quelles réparations d\'iPhone effectuez-vous ?',
    answer: 'Nous remplaçons l\'écran, la batterie, la vitre arrière, le connecteur de charge et la caméra des iPhone, à domicile à Viry et autour de Genève. Le prix et le type de pièce vous sont communiqués avant toute intervention.'
  },
  {
    question: 'Combien de temps prend une réparation d\'iPhone ?',
    answer: 'Nous répondons à votre demande sous 48h maximum et intervenons 7j/7, à toute heure. Une fois sur place, la plupart des réparations prennent entre 30 minutes et 1 journée, selon la panne.'
  },
  {
    question: 'Offrez-vous une garantie sur vos réparations ?',
    answer: 'Toutes nos réparations sont couvertes par une garantie de 90 jours sur les pièces et la main-d\'œuvre. Nous proposons également une politique "satisfait ou remboursé" pour nos interventions à domicile.'
  },
  {
    question: 'Intervenez-vous à domicile ?',
    answer: 'Oui, nous intervenons à domicile pour les particuliers et les entreprises autour de Genève (Ain, Haute-Savoie). Le déplacement est inclus dans le tarif, sans frais cachés.'
  },
  {
    question: 'Combien de temps prend une réparation d\'ordinateur ?',
    answer: 'La plupart des réparations basiques peuvent être effectuées en 24-48 heures. Les problèmes plus complexes peuvent prendre 3-5 jours ouvrables. Nous fournissons toujours une estimation de temps avant de commencer tout travail.'
  },
  {
    question: 'Comment puis-je prendre rendez-vous pour une réparation ?',
    answer: 'Vous pouvez prendre rendez-vous par WhatsApp, par téléphone ou via notre formulaire de contact en ligne. Pour les pannes urgentes, nous proposons souvent des interventions le jour même.'
  },
  {
    question: 'Mon ordinateur est très lent, pouvez-vous l\'accélérer ?',
    answer: 'Oui, l\'optimisation des performances est l\'une de nos spécialités. Nous identifions les causes de la lenteur (logiciels malveillants, trop d\'applications au démarrage, disque dur saturé, mémoire insuffisante) et appliquons des solutions adaptées. Dans la plupart des cas, nous pouvons considérablement améliorer les performances de votre ordinateur sans nécessiter d\'investissement matériel supplémentaire.'
  },
  {
    question: 'Proposez-vous des services pour les TPE/PME ?',
    answer: 'Absolument. Nous offrons des services sur mesure pour les TPE/PME et indépendants : interventions sur site, maintenance et configuration des postes et du réseau, solutions cloud (Microsoft 365, Google Workspace), sécurité et sauvegardes. Contactez-nous pour un devis gratuit et sans engagement.'
  },
  {
    question: 'Pouvez-vous récupérer des données d\'un disque dur défaillant ?',
    answer: 'Dans la plupart des cas, oui. Notre taux de réussite pour la récupération de données est supérieur à 90% pour les disques qui n\'ont pas subi de dommages physiques. Pour les disques physiquement endommagés, nous collaborons avec des services de récupération spécialisés pour maximiser vos chances de récupérer vos données précieuses.'
  },
  {
    question: 'Quelles méthodes de paiement acceptez-vous ?',
    answer: 'Nous acceptons toutes les principales cartes de crédit, PayPal, Apple Pay, Google Pay et les espèces. Pour les clients TPE/PME, nous proposons également des modalités de paiement adaptées.'
  },
];

/** Questions visibles sur la page d'accueil. */
export const HOME_FAQ_SHORT = HOME_FAQ_ITEMS.slice(0, 6);
